import React, { useState } from 'react';

// 定义CSS动画
const animationStyles = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .animate-fade-in {
    animation: fadeIn 0.3s ease-out forwards;
  }
  .rotate-45 {
    transform: rotate(45deg);
  }
`;

const FloatingCTA: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  
  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* 添加全局样式 */}
      <style dangerouslySetInnerHTML={{ __html: animationStyles }} />
      
      {/* 联系选项菜单 */}
      {isOpen && (
        <div className="flex flex-col-reverse mb-4 space-y-reverse space-y-3 animate-fade-in">
          {/* 电话选项 */}
          <a 
            href="tel:0450688920" 
            className="flex items-center justify-center w-12 h-12 rounded-full bg-primary shadow-lg transform transition-transform duration-300 hover:scale-110 text-white"
            aria-label="打电话联系我们"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
            </svg>
          </a>
          
          {/* 邮件选项 */}
          <a 
            href="mailto:michaelremovalists@gmail.com" 
            className="flex items-center justify-center w-12 h-12 rounded-full bg-accent shadow-lg transform transition-transform duration-300 hover:scale-110 text-white"
            aria-label="发送邮件联系我们"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
          </a>
        </div>
      )}
      
      {/* 主按钮 */}
      <button
        onClick={toggleMenu}
        className={`flex items-center justify-center w-16 h-16 rounded-full bg-yellow-400 hover:bg-yellow-300 focus:outline-none shadow-2xl transform transition-transform duration-300 hover:scale-105 text-blue-900 border-2 border-blue-900/20 ${isOpen ? 'rotate-45' : ''}`}
        aria-label={isOpen ? '关闭联系选项' : '打开联系选项'}
        style={isOpen ? { transform: 'rotate(45deg)' } : {}}
      >
        {isOpen ? (
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        ) : (
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
          </svg>
        )}
      </button>
    </div>
  );
};

export default FloatingCTA; 